import { UserDto } from './userDto';

export class CaseHistorySearchFilter {
    objectItem: string;
    subObjectItems: string[];
    dateRange: Date[];
    users: UserDto[];
    searchText: string;
  }
